import { LogNguoiDung } from "../lognguoidung/LogNguoiDung";
import { TaiLieu } from "../nhanvien/TaiLieu";

export class LopDaoTao{
    "id": number;
    "ten": string;
    "ngayBatDau": Date;
    "ngayKetThuc": Date;
    "moTa": string;
    "giangVien": string;
    "hocPhi": number;
    "idHinhThucToChuc": number;
    "tenHinhThucToChuc": string;
    "donViDaoTao": string;
    "diaDiemToChuc": string;
    "soLuongNhanVien": number;
    "ma": string;
    "trangThai": number;
    "idNVTheoDoi": number;
    "idPhoCVP": number;
    "idChanhVP": number;
    "idPhoGiamDoc": number;
    "idGiamDoc": number;
    "tenNVTheoDoi": string;
    "tenPhoCVP": string;
    "tenChanhVP": string;
    "tenPhoGiamDoc": string;
    "tenGiamDoc": string;
    "dsNhanVien": Array<NhanVienTheoLopDaoTao>;
    "logs": Array<LogNguoiDung>;
    "taiLieuTrinh"?: Array<TaiLieu>;
    "isTrinh"?: boolean;
    "trangThai": number;
    /** danh sách file mới chọn để đính kèm khi trình */
    "files"?: Array<any>;
    /** danh sách id TaiLieu_LopDaoTao cần xóa */
    "idsTaiLieuXoa"?: Array<number>;
}

export class TimKiemLopDaoTaoPagingResponse {
    "data": Array<LopDaoTao>;
    "recordsTotal": number;
    "maxPage": number;
    "pageCurrent": number;
    "pageListShow": Array<number>;
}

export class NhanVienTheoLopDaoTao {
    "id": number;
    "hoTen": string;
    "diemDanhGia": string;
    "ketQuaDaoTao": string;
    "isCapChungChi": boolean;
    "idNhanVien": number;
    "idLopDaoTao": number;
    /** thông tin chứng chỉ đã cấp gắn với quá trình đào tạo này */
    "chungChi": ChungChiKetQuaDaoTao | null;
}

/** thông tin chứng chỉ nhập kèm khi cập nhật kết quả đào tạo */
export class ChungChiKetQuaDaoTao {
    /** id bản ghi CHUNGCHI, null khi chưa cấp */
    "idChungChi": number | null;
    "tenChungChi": string;
    "loaiChungChi": string;
    "donViCap": string;
    "ngayCapChungChi": Date | null;
    "xepLoai": string;
    "apDungTuNgay": Date | null;
    "apDungDenNgay": Date | null;
}